import { DisputeInfoResponse, Intent } from '@afterpaytouch/portal-api'

export const isDisputeClosed = (dispute: DisputeInfoResponse): boolean => {
  return dispute?.disputeEntities[0]?.status === 'CLOSE'
}

export const isDisputePendingConsumerResponse = (dispute: DisputeInfoResponse): boolean => {
  return dispute?.disputeEntities[0]?.status === 'INQUIRY' && dispute?.disputeEntities[0].intent === Intent.PendingConsumerResponse
}

export const isDisputePendingConsumerResubmitEvidence = (dispute: DisputeInfoResponse): boolean => {
  return dispute?.disputeEntities[0]?.status === 'INQUIRY' && dispute?.disputeEntities[0].intent === Intent.PendingConsumerResubmitEvidence
}

export const isDisputePendingRepresentmentReview = (dispute: DisputeInfoResponse): boolean => {
  return dispute?.disputeEntities[0]?.status === 'REPRESENTMENT' && dispute?.disputeEntities[0].intent === Intent.PendingRepresentmentReview
}

export const getAttachmentName = (timestamp: number): string => {
  return 'attachment_' + new Date(timestamp).toLocaleString().replace(/:|,| |\//g, '_')
}
